<template>
    <v-main>
        <div style="width:100%;height:50px;"></div>
        <v-container class="pa-0" style="user-select: none;background-color: #bbbbbb;">


            <v-btn class="mt-10" color="#0D47A1" fab fixed top right v-if="taglist.length>0" @click="filterTagList()">
                <span class="white--text">{{taglist.length}}</span>
            </v-btn>

            <v-card outlined flat class="mb-1" v-if="$route.name==='playerpagevideos' && activeplayer">
                <v-card-text>
                    <v-row>
                        <v-col cols="12" class="pa-0 text-center">
                            <router-link :to="'/myathletes/profile/'+this.activeplayer.partkey+''">
                                <v-avatar>
                                    <v-img :src="activeplayer.info.profilepic"/>
                                </v-avatar>
                            </router-link>
                        </v-col>
                        <v-col cols="12" class="pa-0 text-center">
                            {{activeplayer.info.firstname}} {{activeplayer.info.lastname}}
                        </v-col>
                        <v-col cols="12" class="pa-0 text-center">
                            Tagged Video
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-card v-if="!videos">
                <v-card-title>
                </v-card-title>
                <v-card-text v-html="error">

                </v-card-text>
            </v-card>

            <v-list v-if="fileview==='list' && videos" class="py-0">
                <v-list-item v-for="(v,i) in videos"
                             :key="v.partkey + i"
                             @click="handleTagging(v.url720p, v.thumb, v.partkey, i, v.sortkey, v)"
                >
                    <v-list-item-avatar tile>
                        <img :src="thumburl + v.thumb">
                    </v-list-item-avatar>

                    <v-list-item-content class="py-0">
                        <v-list-item-title v-html="v.name || 'no name' "></v-list-item-title>
                        <v-list-item-subtitle>
                            <div>
                                {{ v.createdAt | moment("from", "now") }}
                                <div v-if="v.duration" class="vtimeblocklist">{{ v.duration | moment('mm:ss') }}</div>
                                <v-chip
                                        v-if="v.new"
                                        class="ma-2"
                                        color="white"
                                        small
                                >
                                    <v-icon right color="success" class="pr-2">
                                        mdi-octagram-outline
                                    </v-icon>
                                    <span class="success--text">New</span>
                                </v-chip>
                            </div>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action v-if="tagging" @click="">
                        <v-icon v-if="tagthese.keys.includes(v.sortkey)" color="success">far fa-check-circle
                        </v-icon>
                        <v-icon v-else>fas fa-question</v-icon>
                    </v-list-item-action>
                </v-list-item>
            </v-list>

            <div v-if="fileview==='card' && videos" style="background-color: #fefefe">
                <v-row no-gutters>
                    <v-col cols="12" sm="6" md="4" lg="3"
                           v-for="(v,i) in videos" :key="v.partkey + i"
                           class="pa-0 pa-sm-1"
                    >
                        <VideoCard @click="handleTagging(v.url720p, v.thumb, v.partkey, i, v.sortkey, v)" :video="v"/>
                    </v-col>
                </v-row>
            </div>


        </v-container>
        <!--VIDEO PLAYER DIALOG-->
        <v-dialog
                persistent
                v-model="videodialog"
                v-if="activevideo"
                max-width="1080"
                :fullscreen="$vuetify.breakpoint.smAndDown"
        >
            <v-card color="black" style="height:100%">
                <div class="video-pos-div flex" ref="vidbox">
                    <v-container fluid class="py-0" style="height:100%;">
                        <v-row style="height:100%;" justify="center" align="center">
                            <v-col class="pa-0">
                                <Videoplayer
                                        v-if="!showgamemode"
                                        :src="src"
                                        :poster="poster"
                                        :key="key"
                                        v-on="$listeners"
                                        ref="vp"
                                >
                                </Videoplayer>
                                <GameBreakdownControls
                                        v-else
                                        :gamemodeactive="gamemodeactive"
                                        :src="src"
                                        :poster="poster"
                                        breakdownfilter=1
                                        :startlocation="videolocation"
                                        @toggle="activateGameMode()"
                                        @loaded="gamemodeloading=false"
                                        @closegamemode="gamemodeactive=false,showgamemode=false"
                                />
                                <!--               showgamemode                 Use event data to pass in to setLoop-->

                                <v-list :style="($vuetify.breakpoint.xsOnly)?'':'position: absolute; top:35px;left:0;margin: 5px'"
                                        v-if="showtags && !showgamemode"
                                        dense
                                        width="300"
                                        :color="vplayerbutton"
                                >
                                    <v-list-item>
                                        <v-list-item-action>
                                            <v-btn text color="white" @click="showtags=false">
                                                <v-icon color="white">{{icons.closeol}}</v-icon>
                                                Close
                                            </v-btn>
                                        </v-list-item-action>
                                        <v-list-item-action>
                                            <v-btn text color="white" @click="addtagmodal=true">
                                                Add Tag
                                                <v-icon color="white">{{icons.plus}}</v-icon>
                                            </v-btn>
                                        </v-list-item-action>
                                    </v-list-item>
                                    <v-list-item v-for="(t,i) in tags" :key="i" @click="toPlayer(t)"
                                                 style="background-color: #ffffff55;border-bottom: solid thin #888888;">
                                        <v-list-item-avatar size="35">
                                            <img :src="t.profilepic"/>
                                        </v-list-item-avatar>

                                        <v-list-item-content>
                                            <v-list-item-title class="white--text"
                                                               v-text="t.firstname + ' ' + t.lastname"></v-list-item-title>
                                        </v-list-item-content>

                                        <v-list-item-action v-if="!removetag" class="white--text subtitle-2">
                                            {{t.type}}
                                        </v-list-item-action>
                                        <v-list-item-action v-else>
                                            <v-btn icon @click="removeTag(sportcode,t.type,i)">
                                                <v-icon class="white--text">{{icons.close}}</v-icon>
                                            </v-btn>
                                        </v-list-item-action>
                                    </v-list-item>
                                </v-list>
                                <div v-if="!showgamemode"
                                     style="position: absolute; top:0;display: inline; width:100%;">
                                    <v-btn
                                            :style="`position: absolute; top:35px;left:35px;margin: 5px; ${showgamemode?'border: solid 1px #4caf50; transform: scale(1.2)':''}; `"
                                            fab
                                            x-small
                                            depressed
                                            :color="vplayerbutton"
                                            :loading="gamemodeloading"
                                            @click="activateGameMode(),$refs.vp.Pause(),gamemodeloading=true"
                                            v-if="dev"
                                    >
                                        <v-icon :color="showgamemode?'green':'white'">mdi-chart-timeline-variant
                                        </v-icon>
                                    </v-btn>
                                    <v-btn
                                            style="position: absolute; top:35px;left:0;margin: 5px"
                                            fab x-small depressed
                                            :color="vplayerbutton"
                                            v-if="!showtags"
                                            @click="showtags=true"
                                    >
                                        <v-icon color="white">{{icons.tags}}</v-icon>
                                    </v-btn>
                                    <v-btn
                                            style="position: absolute; top:35px;right:0;margin: 5px"
                                            v-if="!fullscreen"
                                            :color="vplayerbutton"
                                            fab
                                            x-small
                                            depressed
                                            @click="setFullscreen()">
                                        <v-icon color="white">{{icons.fullscreen}}</v-icon>
                                    </v-btn>
                                    <v-btn
                                            v-else
                                            style="position: absolute; top:35px;right:0;margin: 5px"
                                            small
                                            outlined
                                            :color="vplayerbutton"
                                            fab
                                            @click="setFullscreen()"
                                    >
                                        <v-icon color="white">{{icons.exitfull}}</v-icon>
                                    </v-btn>
                                    <v-btn
                                            style="position: absolute; top:0;right:0;margin: 5px"
                                            fab
                                            x-small
                                            depressed
                                            :color="vplayerbutton"
                                            @click="closePlayer()">
                                        <v-icon color="white">{{icons.close}}</v-icon>
                                    </v-btn>
                                    <v-btn
                                            fab
                                            :color="vplayerbutton"
                                            x-small
                                            depressed
                                            @click="gotoeditor()"
                                            style="position: absolute; top:0;right:45px;margin: 5px"
                                    >
                                        <v-icon color="white">{{icons.edit}}</v-icon>
                                    </v-btn>
                                    <v-btn
                                            fab
                                            :color="vplayerbutton"
                                            x-small
                                            depressed
                                            @click="$refs.vp.Pause(),addtoprofilepanel=true"
                                            style="position: absolute; top:75px;right:0;margin: 5px"
                                    >
                                        <v-icon color="white">{{icons.user}}</v-icon>
                                    </v-btn>
                                    <ShareVideo :color="vplayerbutton" :src="src"
                                                v-if="activevideo.uploadedby === cognito.user.username"/>
                                    <v-btn x-small depressed @click="setVideoName()"
                                           style="position: absolute; top:5px;left:50px;margin: 5px"
                                           :color="vplayerbutton" class="white--text"
                                           :disabled="activevideo.uploadedby !== cognito.user.username"
                                    >
                                        <v-icon small class="mr-1">{{icons.edit}}</v-icon>
                                        {{activevideo.name || 'video'}}
                                    </v-btn>
                                    <v-btn
                                            style="position: absolute; top:0;left:0;margin: 5px"
                                            fab
                                            x-small
                                            depressed
                                            :color="vplayerbutton"
                                            @click="markLocation({
                                            notestart: $refs.vp.Location,
                                            partkey:activevideo.partkey,
                                            sortkey:activevideo.sortkey,
                                            src: src,
                                            poster: poster
                                          })"
                                            :dark="marking"
                                            :loading="marking"
                                    >
                                        <v-icon color="white">mdi-bookmark-check-outline</v-icon>
                                    </v-btn>

                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </div>
            </v-card>
        </v-dialog>

        <!--ADD TAG DIALOG-->
        <v-dialog
                v-model="addtagmodal"
                max-width="400"
        >
            <v-card>
                <v-card-title class="headline">Apply Tag</v-card-title>

                <v-card-text>
                    <v-text-field
                            label="Search"
                            v-model:value="string"
                            class="input-group--focused"
                            outlined
                            v-on:input="searchtags"
                            :append-icon="icons.search"
                    ></v-text-field>
                </v-card-text>

                <v-list>
                    <v-list-item v-for="(t,i) in stags"
                                 :key="t.id"
                                 @click="apply(t.firstname, t.lastname, t.playerurl,t.profilepic,t.sport,t.type)">
                        <v-list-item-avatar>
                            <v-btn small icon loading v-if="applyingtag===t.playerurl"></v-btn>
                            <img :src="t.profilepic" v-else/>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title v-text="t.firstname+' '+t.lastname"></v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-list-item-action-text>
                                {{t.type}}
                            </v-list-item-action-text>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>

                <v-card-actions>
                    <v-btn color="green darken-1" text @click.native="addtagmodal = false">Close</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- RENAME  DIALOG -->
        <v-dialog
                v-model="renamevideodialog"
                v-if="activevideo"
                max-width="400"
        >
            <v-card>
                <v-card-title class="headline">Rename Video</v-card-title>

                <v-card-text>
                    <v-text-field
                            label="name"
                            v-model="activevideo.name"
                            class="input-group--focused"
                    ></v-text-field>
                    <v-text-field
                            label="description"
                            v-model="activevideo.description"
                            class="input-group--focused"
                    ></v-text-field>

                </v-card-text>

                <v-card-actions>
                    <v-btn color="green darken-1" text @click.native="saveVideoName()" :loading="savingvideo">Save
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click.native="renamevideodialog = false,savingvideo=false">
                        Cancel
                    </v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>

        <AddVideoToProfile :dialog="addtoprofilepanel" @close="addtoprofilepanel=false"/>

        <v-toolbar dense style="width:100%;position:fixed;top:48px;">
            <v-btn :disabled="offset===0" text @click="offset-=40,getRecentVideos(offset),loadingnewer=true"
                   :loading="loadingnewer">
                <v-icon>{{icons.arrowleft}}</v-icon>
                <span class="hidden-xs-only">Newer 40</span>
            </v-btn>
            <v-spacer/>
            <v-btn text small
                   @click="sortnameasc=(sortnameasc===true)?false:(sortnameasc===false)?undefined:true, sortdateasc=undefined, Sort('name',sortnameasc)">
                <v-icon v-if="sortnameasc===true" color="blue">mdi-sort-alphabetical-ascending</v-icon>
                <v-icon v-if="sortnameasc===false" color="blue">mdi-sort-alphabetical-descending</v-icon>
                <v-icon v-if="sortnameasc===undefined">mdi-sort-alphabetical-variant</v-icon>
            </v-btn>
            <v-btn text small
                   @click="sortdateasc=(sortdateasc===true)?false:(sortdateasc===false)?undefined:true,sortnameasc=undefined,  Sort('createdAt',sortdateasc)">
                <v-icon v-if="sortdateasc===true" color="blue">mdi-calendar-import</v-icon>
                <v-icon v-if="sortdateasc===false" color="blue">mdi-calendar-export</v-icon>
                <v-icon v-if="sortdateasc===undefined">mdi-sort-numeric-variant</v-icon>
            </v-btn>
            <v-btn text small v-if="dev" @click="createtaglist = ! createtaglist">
                <v-icon :color="createtaglist?'#0D47A1':'grey lighten-1'">{{icons.checkon}}</v-icon>
            </v-btn>
            <v-btn text small v-if="fileview==='card'" @click="setFileView('list')">
                <v-icon>{{icons.list}}</v-icon>
                <span class="hidden-xs-only">View List</span>
            </v-btn>
            <v-btn text small v-if="fileview==='list'" @click="setFileView('card')">
                <v-icon>{{icons.card}}</v-icon>
                <span class="hidden-xs-only">View Cards</span>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn :disabled="videos && videos.length<40" text
                   @click="offset+=40,getRecentVideos(offset),loadingolder=true" :loading="loadingolder">
                <span class="hidden-xs-only">Next 40</span>
                <v-icon>{{icons.arrowright}}</v-icon>
            </v-btn>
        </v-toolbar>
    </v-main>
</template>


<script>
  // import Date from '@/components/Date'
  import {
    mapState,
    mapActions,
    mapMutations
  } from 'vuex'
  import Videoplayer from '@/views/video/VideoJsPlayer'
  import AddVideoToProfile from "@/views/a4l/playercomponents/AddVideoToProfile";
  import orderBy from 'lodash'
  import ShareVideo from "../../components/ShareVideo";
  import VideoCard from "./VideoCard";

  export default {
    //props:['activeplayer'],
    components: {
      VideoCard,
      ShareVideo,
      AddVideoToProfile,
      GameBreakdownControls: () => import('@/views/video/breakdown/GameBreakdownControls'), //this way it will not load the postentially heavy component unless its requested..
      Videoplayer
    },
    name: 'Videos',
    data() {
      return {
        sharedialog: false,
        textcopied: false,
        max: 1,
        notetags: [],
        notehelperdialog: false,
        noteplaybackrate: 1,
        thumburl: 'https://videos.athleteforlife.org/',
        videourl: 'https://videos.athleteforlife.org/',
        imgurl: 'https://s3-us-west-2.amazonaws.com/imgforlife/',
        // videos:false,
        error: '..getting videos',
        src: '',
        poster: '',
        videodialog: false,
        key: '',
        videoname: '',
        savingvideo: false,
        videoid: '',
        videoduration: '',
        tags: '',
        stags: false,
        taglist: [],
        createtaglist: false,
        removetag: false,
        applyingtag: false,
        videogroup: false,
        string: '',
        addtagmodal: false,
        sharelink: null,
        panel1: true,
        playing: true,
        playbackrate: 1,
        addtoprofilepanel: false,
        videome: '',
        videotitle: '',
        showtags: false,
        tile: true,
        videoeditdisabled: true,
        renamevideodialog: false,
        newvideoname: '',
        newvideodescription: '',
        tempvideo: '',
        videomonth: '',
        videoyear: '',
        months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        loadingbydate: false,
        fullscreen: false,
        gamecolor: ['red', 'orange', 'blue'],
        gamehover: ['OFF', 'BREAKDOWN', 'REVIEW'],
        enablemodeval: 0,
        showgamemode: false,
        gamemodeactive: false,
        //extract
        videomarkers: undefined,
        gamemodeloading: false,
        sortnameasc: undefined,
        sortdateasc: undefined,
        fileview: 'card',
        videolocation: undefined,
        offset: 0,
        loadingnewer: false,
        loadingolder: false
      }
    },
    computed: {
      ...mapState(['icons', 'org', 'activeplayer', 'activevideolist', 'sportcode', 'cognito', 'tagging', 'activevideo', 'marking', 'dev']),
      player() {
        return this.activeplayer.info
      },
      videos() {
        return this.activevideolist
      },
      vplayerbutton() {
        return '#000000' + '33'
      }
    },
    watch: {
      async $route(n) {
        if (n.params.playerkey) {
          let e = {partkey: n.params.playerkey}
          this.videogroup = false
          await this.selectPlayer(e.partkey)
          this.getVideos(e.partkey)
          this.$forceUpdate()
        }
        if (n.name === 'Myvideos') {
          this.getRecentVideos(0)
        }
      },
      addtagmodal: function () {
        if (!this.addtagmodal) {
          this.stags = '';
          this.string = '';
        }
      },
      fullscreen(n, o) {
        console.log(n, o)
      },
      videos() {
        this.loadingnewer = false;
        this.loadingolder = false;
      }
    },
    async created() {
      console.log(this.$route.params.playerkey)
      if (this.$route.name === 'playerpagevideos') {
        if (!this.activeplayer) {
          await this.selectPlayer(this.$route.params.playerkey)
          this.getVideos(this.$route.params.playerkey)
        }
      } else {
        this.getRecentVideos()
      }
    },
    mounted() {
      this.tempvideo = document.createElement('video');
      this.tempvideo.crossOrigin = "anonymous"
      let d = new Date();
      this.videomonth = d.getMonth();
      this.videoyear = d.getFullYear();
      if (this.$route.name === 'myVideos') {
        this.getRecentVideos()
      }
      this.fileview = window.localStorage.getItem('fileview') || 'card'
      this.clearVideoNotification()
    },
    methods: {
      ...mapActions(['get', 'post', 'put', 'selectPlayer', 'getRecentVideos', 'getVideosByTag', 'markLocation', 'getPlaysByGame']),
      ...mapMutations(['setVideoList', 'setActiveVideo', 'setNtfs']),
      async switchPlayerUrl(e) {
        this.videogroup = false
        this.$router.replace('/videos/' + this.sportcode + '/' + e.partkey + '/videos')
        await this.selectPlayer(e.partkey)
        this.getVideos(e.partkey)
        this.$forceUpdate()
      },
      async getVideos(groupname) {
        await this.getVideosByTag(groupname)
      },
      async getVideosByDate() {
        if (this.$route.name !== 'Myvideos') {
          this.$router.replace('/videos')
        }
        let data;
        this.loadingbydate = true
        if (this.$route.name === 'Myvideos') {
          data = {
            date: this.months[this.videomonth] + ' ' + this.videoyear,
            partkey: this.cognito.user.username
          }
        } else {
          data = {
            date: this.months[this.videomonth] + ' ' + this.videoyear,
            partkey: this.activeplayer.partkey
          }
        }
        let res = await this.post({path: 'api/video/bymonth', body: data})
        this.loadingbydate = false
        this.videogroup = 'month'
        if (typeof res.message == 'undefined' && Object.keys(res).length > 0) {
          this.setVideoList(res)
        } else {
          console.log('No Videos');
          this.setVideoList(false)
          this.error = ' No videos here, yet.<br/> Want to upload one? <br/>Go to your <a href="#/uploadvideo">UPLOADS</a>';
        }
      },
      async setSrc(src, poster, partkey, sortkey) {   ///this needs to be more set on the $store
        console.log(partkey, sortkey)
        this.key = partkey + sortkey; //facilitates reactivity -> :key on video
        this.videodialog = true;
        this.src = this.videourl + src;
        this.poster = this.thumburl + poster;
        this.videoname = partkey + sortkey;
        this.videoid = sortkey;
        let res = await this.get({path: 'api/video/get/' + partkey + '/' + sortkey})
        console.log('Videoresponse:', res);
        if (res) {
          res.poster = this.poster
          this.setActiveVideo(res)
          window.localStorage.setItem('activevideo', JSON.stringify(res))
          //this.activevideo = res.Item;
          this.tags = Object.values(res.tags2).filter(f => {
            return f.type
          });
          this.videoeditdisabled = (
            res.uploadedby === this.cognito.user.attributes.email &&
            res.uploadedby === this.cognito.user.username &&
            res.uploadedby === this.$store.state.orgkey)
        }
        let index = this.videos.findIndex(f => (f.sortkey === this.activevideo.sortkey && f.partkey === this.activevideo.partkey))
        let tmp = this.activevideolist[index]
        tmp.views = this.activevideo.views + 1
        this.$set(this.activevideolist, index, tmp)
      },
      makepublic() {
      },

      activateGameMode() {
        let em = this
        this.videolocation = this.$refs.vp.Location
        setTimeout(function () {
          if (em.showgamemode) {
            em.gamemodeactive = !em.gamemodeactive
          } else {
            em.showgamemode = true
          }
          em.gamemodeloading = false
        }, 1000)

      },

      sharevideo(part, sort) {
        let em = this;
        let args = {
          url: this.$store.state.url + 'api/video/share',
          method: 'POST',
          data: {
            user: this.$store.state.token.email,
            tags: em.tags,
            val: {
              partkey: this.activevideo.partkey,
              sortkey: this.activevideo.sortkey,
              thumb: this.$store.state.thumburl + this.activevideo.info.thumb,
              url720p: this.src,
              user: this.$store.state.token.email
            }
          }
        }
        this.$store.dispatch('fetch', args)
          .then(function (data) {
            console.log(data);
            var link = window.location.host + '/#/watch/' + data.link;
            em.sharelink = link;
            console.log(link);
          }).catch(function (e) {
          console.log(e);
        })
      },
      swipe(d) {
        this.$refs.vidc.left = d;
      },
      async searchtags() {
        if (this.string == null || this.string == '' || !this.string) {
          this.stags = false;
          return;
        }
        let data = {
          string: this.string,
          sport: this.sportcode,
          tags: this.tags
        }
        let st = await this.post({path: 'api/video/searchtags2', body: data})
        this.stags = st.filter(f => {
          return f
        })
      },
      async apply(a, b, c, d, e, f) {
        let data = {
          partkey: this.activevideo.partkey,
          sortkey: this.activevideo.sortkey,
          createdat: this.activevideo.info.createdat,
          firstname: a,
          lastname: b || '-Club',
          playerurl: c,
          profilepic: d,
          sport: e,
          type: f
        }
        this.applyingtag = c
        let res = await this.put({path: 'api/video/applytag2', body: data})
        this.applyingtag = false
        if (res.code === "ConditionalCheckFailedException") {
          this.stags = false;
          this.string = '';
        } else {
          this.tags.push({
            firstname: a,
            lastname: b,
            playerurl: c,
            profilepic: d,
            sport: e,
            type: f
          })
          this.stags = false;
          this.string = null;
        }
      },
      async removeTag(sport, type, playerkey) {
        let data = {
          partkey: this.activevideo.partkey,
          sortkey: this.activevideo.sortkey,
          playerurl: playerkey,
          sport: sport,
          type: type
        }
        await this.put({path: 'api/video/removetag2', body: data})
        this.removetag = false
        delete this.tags[playerkey]
        this.stags = false;
        this.string = null;
      },
      handleTagging(url, thumb, partkey, index, sortkey, name) {
        //index is sortkey of object, sortkey is sortkey of array
        if (name.new) {
          this.clearWatched(name.id)
        }
        if (!this.tagging) {
          if (!sortkey) sortkey = index
          this.setSrc(url, thumb, partkey, sortkey)
        } else {
          C('tagthese', {[i]: v, type: 'videos'})
        }
      },
      tagthese(state, t) {
        //sometimes the sort key isnt in the tag meta data ie older videos
        //these are what we are tagging
        console.log('T: ', t)
        let key = Object.keys(t)[0];
        t[key].sortkey = key;
        t[key].type = t.type;
        let ths = state.tagthese; //reset if it lacks.. this might be dangerous later,
        if (ths.keys.includes(key)) {
          let i = ths.keys.indexOf(key);
          ths.keys.splice(i, 1)
          ths.items.splice(i, 1)
        } else {
          ths.keys.push(key)
          ths.items.push(t[key])
        }
        state.tagthese = ths;
        console.log('Tag These', state.tagthese)
      },
      handlespeed() {
        this.$refs.vp.speed();
        this.playbackrate = this.playbackrate == 1 ? .5 : 1;
      },
      addtogroup() {
        var em = this;
        let args = {
          url: this.$store.state.url + 'api/video/addtogroup',
          method: 'PUT',
          data: {
            name: 'GROUP NAME!!'
          }
        }
        var data = {
          token: this.$store.state.token,
          name: 'GROUP NAME!!'
        }
        this.axios.put(this.$store.state.url + 'api/video/addtogroup', data)
          .then(function (rdata) {
            console.log(rdata.data);
          }).catch(function (e) {
          console.log(e);
        })
      },
      tagd() {
        this.$store.commit('tagdialog', true)
      },
      gotoeditor() {
        window.localStorage.setItem('scrublocation', this.$refs.vp.Location.toFixed(2))
        this.$router.push({path: '/videobreakdown'})
      },
      setVideoName() {
        this.renamevideodialog = true
      },
      async saveVideoName() {
        console.log(this.$refs.vp.Duration)
        this.savingvideo = true
        let tm = this.activevideo.timestamp || this.activevideo.info.createdat
        let duration = parseInt(this.$refs.vp.Duration)
        let data = {
          name: this.activevideo.name,
          description: this.activevideo.description,
          sortkey: this.activevideo.sortkey,
          partkey: this.activevideo.partkey,
          duration: duration,
          createdat: tm
        }
        let res = await this.put({path: 'api/video/rename', body: data})
        let index;
        index = this.videos.findIndex(f => (f.sortkey === this.activevideo.sortkey && f.partkey === this.activevideo.partkey))
        let tmp = this.activevideolist[index]
        tmp.name = this.activevideo.name
        tmp.description = this.activevideo.description
        tmp.duration = duration; //this can be removed at a later date (after all back records are updated)
        tmp.createdat = tm
        this.$set(this.activevideolist, index, tmp)

        console.log(index)
        this.savingvideo = false
        this.renamevideodialog = false
      },
      setFullscreen() {
        let elem = this.$refs.vidbox;
        let em = this;
        elem.addEventListener("fullscreenchange", function (event) {
          em.screencheck()
        });
        if (!document.fullscreenElement) {
          elem.requestFullscreen().then({/*do nothing else for now*/}).catch(err => {
            alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
          });
        } else {
          document.exitFullscreen();
        }
      },
      screencheck() {
        if (document.fullscreenElement) {
          this.fullscreen = true;
        } else {
          this.fullscreen = false;
        }
      },
      closePlayer() {
        clearInterval(this.videoloop)
        if (document.fullscreenElement) {
          document.exitFullscreen();
        }
        this.removetag = false
        this.videodialog = false
        this.src = null
        this.sharelink = ''
        this.videoeditdisabled = false
        this.fullscreen = false
        this.showtags = false
        this.showgamemode = false
        this.gamemodeactive = false
        this.$refs.vp.Pause()
      },
      shareToFacebook(src) {
        let url = 'https://www.facebook.com/sharer/sharer.php?u=' + src + '&title=' + this.activevideo.name + '&description=' + this.activevideo.description + '&hashtag=athleteforlife&image=' + this.poster
        console.log(src + '&title=' + this.activevideo.name + '&description=' + this.activevideo.description + '&hashtag=athleteforlife&image=' + this.poster)
        window.open(url, "", "width=500,height=500,screenX=100,screenY=100")
      },
      async notesInVideo() {
        this.videomarkers = await this.get({path: 'api/notes/notesinvideo'})
        console.log(this.videomarkers)
      },
      Sort(prop, dir) {
        //let v = Object.assign({},this.videos)
        let ar = Object.values(this.videos)
        console.log(prop, dir)
        if (dir === true) {
          ar.sort((a, b) => (a[prop] > b[prop]) ? 1 : -1)
        } else if (dir === false) {
          ar.sort((a, b) => (a[prop] < b[prop]) ? 1 : -1)
        } else {

        }
        this.setVideoList(ar)
      },
      toPlayer(v) {
        console.log(v)
        this.$router.push('/pwall/' + v.playerurl + '?rd=openvideo&pk=' + this.activevideo.partkey + '&sk=' + this.activevideo.sortkey)
      },
      setFileView(v) {
        this.fileview = v
        window.localStorage.setItem('fileview', v)
      },
      async tagList(v) {
        console.log(v.sortkey, this.taglist.includes(v.sortkey))
        if (this.taglist.includes(v.sortkey)) {
          let index = await this.taglist.findIndex(i => i === v.sortkey)
          console.log(index)
          if (index >= 0) {
            this.taglist.splice(index, 1)
          }
        } else {
          this.taglist.push(v.sortkey)
        }

        console.log(this.taglist)
      },
      filterTagList() {
        let f = this.videos.filter(f => {
          return this.taglist.includes(f.sortkey)
        })
        console.log(f)
      },
      clearVideoNotification() {
        let n = this.$store.state.notifications;
        let arr = []
        for (let i = 0; i < n.length; i++) {
          console.log(n[i].code, i)
          arr.push(i)
        }
        if (arr.length === 0) return
        let tmp = n.filter(f => {
          return f.code !== 'newvideo'
        })
        this.setNtfs(tmp)
        this.post({path: 'api/video/clearnewvideo', body: {indexes: arr}})
      },
      async clearWatched(id) {
        await this.post({path: 'api/video/clearwatched', body: {id: id}})
        let index;
        index = this.videos.findIndex(f => (f.id === id))
        let tmp = this.activevideolist[index]
        tmp.new = false
        this.$set(this.activevideolist, index, tmp)
      }
    }
  }
</script>

<style scoped>
    .vcheckbox {
        position: absolute;
        top: 2px;
        right: 2px;
    }

    .vtimeblock {
        display: inline;
        padding: 3px;
        background-color: black;
        color: white;
        font-weight: bold;
        font-size: .7em;
        position: absolute;
        bottom: 2px;
        right: 2px;
    }

    .vtimeblocklist {
        display: inline;
        padding: 3px;
        background-color: black;
        color: white;
        font-weight: bold;
        font-size: .7em;
    }

    .newclass {
        border: solid thin red;
        background-color: #eeff41;
    }

    .video-pos-div {
        position: relative;
        display: block;
        background-color: black;
        /*overflow: hidden;*/
    }

    .active {
        background-color: #303F9F;
        color: #ffffff;
    }

    .notecursor {
        width: 4px;
        height: 70px;
        background-color: darkblue;
        border: solid thin #232323;
        position: absolute;
    }

    .chromeol {
        border: solid thin black;
        border-radius: 3px;
    }

    .start {
        vertical-align: middle;
        display: inline-block;
        border: solid thin black;
        border-radius: 3px;
        width: 80px;
        text-align: center;
    }

    .starticons {
        vertical-align: middle;
        display: inline-block;
        color: black;
    }

    .loopmessage {
        display: block;
        position: absolute;
        top: 0;
        z-index: 999;
        font-size: 1.5em;
        font-weight: bold;
        color: #fff;
        width: 100%;
        height: 200px;
    }

    .loopnote {
        display: block;
        position: absolute;
        bottom: 100px;
        z-index: 999;
        color: #fff;
        background-color: rgba(0, 0, 0, .5);
        width: 100%;
        cursor: pointer;
    }

    .full {
        width: auto;
    }

    .infobox {
        border: solid thin #555555;
        border-radius: 3px;
        padding: 5px;
        display: inline-block;
        width: 60px;
        text-align: left;
        float: right;
    }

    .tagsearcher {
        width: 200px;
    }

    .videoplayer {
        max-height: 400px;
    }

    .playicon {
        transform: scale(3);
        width: auto;
        left: 50%;
        position: absolute;
        top: 50%;
        color: pink;
    }

    .vidcontainer {
        z-index: 4 !important; /*needs to be higher than the <footer>, so that it fullscreens whe it rotates*/
        position: fixed;
        top: 0;
        left: 0;
        background-color: #888888;
        width: 100%;
        height: auto;
        text-align: center;
    }

    .videoplayer {
        width: 100%;
        max-width: 1920px;
    }

    .a4ltools {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        max-width: 1920px;
        height: 50px;
        border: solid thin #FFF;
    }

    .a4ltoolbtn {
        height: 100%;
        width: 50px;
        border: solid thin #fff;
        line-height: 80%;
        vertical-align: middle;
        font-size: 2em;
        color: #FFFFFF;
        float: left;
    }

    .a4lpress {
        position: absolute;
        top: 50px;
        left: 0;
        width: 100%;
        max-width: 1920px;
        height: 100%;
        border: solid thin #00acc1;
    }

    .rotate-transition {
        transition: all .3s ease;
        transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
    }

    .rotate.v-enter, .rotate.v-leave {
        transition: all .3s ease;
        transform: rotate(-90deg);
        -webkit-transform: rotate(-90deg);
    }

    .videocard {
        padding: 0;
        margin-bottom: 10px;
        width: 100%;
        height: 200px;
        background-color: #111111;
        color: #FFF;
    }

    .cardcontainer {
        width: 100%
    }

    .superfloat {
        z-index: 10
    }
</style>

<!--<v-card flat @click="handleTagging(v.url720p, v.thumb, v.partkey, i, v.sortkey, v)"-->
<!--        color="transparent"  :width="$vuetify.breakpoint.xsOnly?undefined:210"-->
<!--        class="mb-2">-->
<!--    <v-img-->
<!--            :src="thumburl + v.thumb"-->
<!--            :height="$vuetify.breakpoint.xsOnly?180:118"-->
<!--    >-->

<!--        <v-chip-->
<!--                v-if="v.new"-->
<!--                class="ma-2"-->
<!--                color="white"-->
<!--                small-->
<!--        >-->
<!--            <v-icon left color="success">-->
<!--                mdi-octagram-->
<!--            </v-icon>-->
<!--            <span class="success&#45;&#45;text">New</span>-->
<!--        </v-chip>-->
<!--        <div class="vcheckbox" v-if="createtaglist">-->
<!--            <v-btn @click.stop="tagList(v)" icon color="white" style="background-color: #0D47A1;">-->
<!--                <v-icon color="white" v-if="taglist.includes(v.sortkey)">{{icons.checkon}}</v-icon>-->
<!--                <v-icon v-else>{{icons.checkoff}}</v-icon>-->
<!--            </v-btn>-->
<!--        </div>-->
<!--        <div class="vtimeblock" v-if="v.duration">-->
<!--            {{ v.duration | moment('mm:ss') }}-->
<!--        </div>-->
<!--    </v-img>-->
<!--    <v-card-text class="py-1" style="height:66px;overflow: hidden;">-->
<!--        <h4>-->
<!--            {{v.name}}-->
<!--        </h4>-->
<!--        <div style="width:100%; font-size: x-small;">-->
<!--            {{v.description}}-->
<!--        </div>-->
<!--    </v-card-text>-->
<!--    <v-card-actions>-->
<!--        <span class="caption" v-if="!v.views">no views</span>-->
<!--        <span class="caption" v-if="v.views>1">{{v.views}} views</span>-->
<!--        <span class="caption" v-if="v.views===1">{{v.views}} view</span>-->
<!--        <div class="px-1"> &#8226 </div>-->
<!--        <span style="font-size: x-small" v-if="v.createdat">-->
<!--                                        {{ v.createdat | moment("from", "now") }}-->
<!--                                    </span>-->
<!--        <span style="font-size: x-small" v-else-if="v.createdAt">-->
<!--                                        {{ v.createdAt | moment("from", "now") }}-->
<!--                                    </span>-->
<!--        <v-spacer />-->
<!--        <v-icon small v-if="v.sharedwithkey && v.ownerkey!==v.sharedwithkey">{{icons.share}}</v-icon>-->
<!--    </v-card-actions>-->
<!--</v-card>-->
